import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { css } from 'components/_UI/designSystem';
import NativeFlex from '../Bits/NativeFlex';
import { NativeColorMode } from '../../../widgets/PostsWidget/types';
import { getNativeColor } from '../Helpers';
import { Emoji } from '@sprinklr/stories/widget/types';

// NativeTitle
type FontSize = 's' | 'm' | 'l';

export type NativeTitleProps = {
    title: string;
    colorMode?: NativeColorMode;
    maxCharacters?: number;
    emoji?: Emoji;
};

type StyledTextProps = {
    size?: FontSize;
};

const colors = {
    darkGrey: '#333',
    lightGrey: '#bababd',
};

const theme = {
    light: {
        text: colors.darkGrey,
    },
    dark: {
        text: colors.lightGrey,
    },
};
type StyledProps = {
    colorMode?: NativeColorMode;
    size?: FontSize;
    emoji?: Emoji;
    maxCharacters?: number;
};
export const StyledEmoji = styled.img`
    vertical-align: middle;
`;
const StyledNativeTitle = styled(NativeFlex)<StyledProps>`
    ${({ colorMode }) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'text')};
        `}
    ${StyledEmoji} {
        height: 1em;
        width: 1em;
    }

    font-size: 1.5em;
    font-weight: 650;
    line-height: 1.2;
    padding-bottom: 1em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
`;
StyledNativeTitle.displayName = 'StyledNativeTitle';

const NativeTitle: React.FC<NativeTitleProps> = ({
    title,
    maxCharacters = 200,
    emoji = {
        platform: 'default',
    },
    colorMode = 'light' as NativeColorMode,
}) => {
    return (
        <StyledNativeTitle
            emoji={emoji}
            colorMode={colorMode}
            data-id='native-title'
            noGrow
            maxCharacters={maxCharacters}
            size={'l'}>
            {title}
        </StyledNativeTitle>
    );
};

NativeTitle.displayName = 'NativeTitle';
export default observer(NativeTitle);
export { StyledNativeTitle };
